export var ECustomerType;
(function (ECustomerType) {
    ECustomerType[ECustomerType["Customer without type"] = 0] = "Customer without type";
    ECustomerType[ECustomerType["Personal"] = 1] = "Personal";
    ECustomerType[ECustomerType["Business"] = 2] = "Business";
})(ECustomerType || (ECustomerType = {}));
